var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Admin',{staticStyle:{"background":"#f2f2f2"}},[_c('v-main',[_c('profile-detail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }